module.exports = __webpack_public_path__ + "media/images/the-information-logo-for-dark-652e462e.svg";